import React from "react";
import HandshakeLogoPng from "../../assets/images/png/Handshake.png";

const HandShakeLogo = (): React.ReactElement => {
    return (
        <img src={HandshakeLogoPng} style={{ width: "3em", height: "2em", paddingBottom: "0.8em" }} alt="handshake" />
    );
};

export default HandShakeLogo;
